// src/pages/trading-portal/MarketDataIngestion/OptionsPayoffPage.js
// Standalone page for options payoff visualization

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Chip } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import OptionsPayoffVisualizer from './OptionsPayoffVisualizer';

const fontFamily = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif";
const ACCENT = '#f59e0b';

const OptionsPayoffPage = () => {
    const { contractId } = useParams();
    const navigate = useNavigate();

    // Read contract metadata from navigation state
    const state = window.history.state?.usr || {};
    const symbol = state.symbol || '';
    const strikePrice = state.strikePrice || '';
    const optionType = state.optionType || '';

    return (
        <Box sx={{ p: 3, fontFamily }}>
            {/* Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate(-1)}
                    sx={{ color: '#94a3b8', textTransform: 'none', fontFamily, fontWeight: 600 }}
                >
                    Back to Options Chain
                </Button>
                <Typography variant="h5" fontWeight="bold" sx={{ fontFamily }}>
                    Payoff Matrix
                </Typography>
                {symbol && (
                    <Chip
                        label={`${symbol} $${strikePrice} ${optionType}`}
                        color={optionType === 'CALL' ? 'success' : 'error'}
                        size="small"
                    />
                )}
            </Box>

            {/* Visualizer */}
            <OptionsPayoffVisualizer contractId={parseInt(contractId, 10)} />
        </Box>
    );
};

export default OptionsPayoffPage;
